@if (label(); as statusLabel) {
  <app-task-message-status
    [messageStatus]="taskMessageStatus()"
    [customLabel]="statusLabel"
    [reason]="errorMessage()"
    [header]="errorMessage() ? 'External status' : null"
    [showTooltip]="!!errorMessage()"
  ></app-task-message-status>
}
